import React from 'react';
import ChoiceCheckbox from '../components/choice-checkbox';

type Props = {
  name?: string;
  checked?: boolean;
  disabled?: boolean;
  colorStyle?: string;
  onChange?: (checked: boolean) => void;
  children?: React.ReactNode | React.ReactNode[];
};

const ControlledCheckbox = React.forwardRef(
  (
    { name, checked, disabled, colorStyle, onChange, children, ...rest }: Props,
    ref: React.Ref<HTMLInputElement>,
  ) => (
    <ChoiceCheckbox
      innerRef={ref}
      name={name}
      checked={checked}
      colorStyle={colorStyle}
      disabled={disabled}
      onChange={onChange}
      {...rest}
    >
      {children}
    </ChoiceCheckbox>
  ),
);

export default ControlledCheckbox;
